module.exports = __webpack_public_path__ + "static/img/extracciones-kids.1fdd265.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/extracciones-kids.jpg
// module id = PdO8
// module chunks = 1